import { EventNames } from "core/monitoring/types/enums";
import React from "react";
import { RoundedCard } from "shared/UI/RoundedCard/RoundedCard";
import SafeSpaceImage from "shared/assets/SafeSpacesImage.png";
import axios from "axios";
import { t } from "i18next";
import { trackEvents } from "core/monitoring/Events";
import { useNotifyModalContext } from "shared/core/state/NotifyModalContext/NotifyModalContext";

interface SafeSpacesProps {
  className?: string;
}

const homeIsAliveUrl = "https://safespaces.azurewebsites.net/Home/IsAlive";
const safeSpacesPageUrl = "https://safespaces.azurewebsites.net/";

export function SafeSpaces({ className }: SafeSpacesProps) {
  const { modalNotify } = useNotifyModalContext();

  function handleClick() {
    trackEvents(EventNames.SAFE_SPACE_CLICK);
    isSafeSpaceAvailable()
      .then(() => launchSafeSpace())
      .catch(() => {
        modalNotify("error", t("safeSpaces.errorTitle"), t("safeSpaces.error"), t("safeSpaces.errorCta"));
      });
  }

  function isSafeSpaceAvailable() {
    return axios.get(homeIsAliveUrl);
  }

  const launchSafeSpace = () => {
    const targetElement = document.body;

    axios.get(safeSpacesPageUrl).then((response) => {
      hostWidgetInIframe(response.data, targetElement);
    });
  };

  const hostWidgetInIframe = (resultHtml: string, targetEl: HTMLElement) => {
    const iframe = document.createElement("iframe");
    iframe.setAttribute("id", "safe-space-iframe");
    iframe.setAttribute("title", "safe-space-widget-iframe");

    targetEl.appendChild(iframe);
    targetEl.style.overflow = "hidden";
    iframe.setAttribute(
      "style",
      "height:100%;width:100%;position:fixed;top:0;bottom:0;padding:3rem 0px;background-color: rgba(0, 0, 0, 0.26);z-index:9999;"
    );

    iframe.contentWindow?.document.open();
    iframe.contentWindow?.document.write(resultHtml);
    iframe.contentWindow?.document.close();
    iframe.focus();
  };

  return (
    <div className={"flex items-center justify-center"}>
      <button onClick={handleClick} className={`w-full relative ${className} inline`}>
        <RoundedCard className="flex items-center justify-center p-4">
          <img src={SafeSpaceImage} alt={"safe space"} className="h-[250px] object-contain max-h-full" />
        </RoundedCard>
      </button>
    </div>
  );
}
